import lang from "@/views/modules/Comments/language/en";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-comment",
   
    components: {
     //   'editor': Editor,
    },
    data() {
        return {
            loading: true,
            comment: {},
            lang:[],
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        saveComment() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/comments', self.comment).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/comments/' + response.data.comment.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}